// CORE-1735 slice 17 (D-120, QA V06) — Live icon «practice» from the published set v4.2
// (Confluence 110461314, archive reference-icons-v4.2): geometry as shipped, strokes 1.8,
// paint from the caller (`color` — solid or an ink gradient reference), the inner
// highlight through `filter` (the toolbar's «live-polish»), the slash cut by `cut`.
import React from 'react';
import Svg, { G, Circle, Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Practice: React.FC<LiveGlyphProps> = ({ size, color, accent, filter }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <G filter={filter} fill={color} fillRule="evenodd">
    <Circle cx={12} cy={11} r={3.4} fill={color} />
    <Path d="M5 23v-2a7 7 0 0 1 14 0v2Z" fill={color} />
    <Path d="M12 1v3 M4 4l2 2 M1 11h3 M20 11h3 M18 6l2-2" fill="none" stroke={accent ?? color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" />
    </G>
  </Svg>
);
